import APIClient from '@/shared/http/clients/api'

const resourceName = 'obracandidato'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (obraID, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/obra/${obraID}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}`, data, config)
const UpdateSelection = (data = {}, config = {}) => APIClient.put(`${APIBusinessCommon}/${resourceName}/selecao`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}`, data, config)
const Delete = (obraMembroID, data = {}, config = {}) => APIClient.delete(`${APIBusinessCommon}/${resourceName}/${obraMembroID}`, data, config)

const ConstructionCandidateRepository = {
  GetAll,
  Update,
  UpdateSelection,
  Delete,
  Create
}

export default ConstructionCandidateRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/constructioncandidates.js